import { Details } from '../../gql/graphql';

export const getTotalCartAmount = (details: Details) => {
  let totalCartAmount = 0;

  try {
    details?.items?.forEach((item) => {
      totalCartAmount += item.quantity * parseFloat(item.price);
    });

    if (details?.shippingAmnt) {
      totalCartAmount += parseFloat(details?.shippingAmnt);
    }
  } catch (err) {
    console.error('could not compute items total amount: ', err);
  }
  return totalCartAmount;
};
